export const XMarkThinIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8529 2.64494C13.8995 2.69139 13.9364 2.74656 13.9617 2.80731C13.9869 2.86805 13.9998 2.93317 13.9998 2.99894C13.9998 3.06471 13.9869 3.12983 13.9617 3.19057C13.9364 3.25132 13.8995 3.3065 13.8529 3.35294L2.85294 14.3529C2.75905 14.4468 2.63172 14.4996 2.49894 14.4996C2.36616 14.4996 2.23883 14.4468 2.14494 14.3529C2.05105 14.2591 1.99831 14.1317 1.99831 13.9989C1.99831 13.8662 2.05105 13.7388 2.14494 13.6449L13.1449 2.64494C13.1914 2.59838 13.2466 2.56143 13.3073 2.53623C13.3681 2.51102 13.4332 2.49805 13.4989 2.49805C13.5647 2.49805 13.6298 2.51102 13.6906 2.53623C13.7513 2.56143 13.8065 2.59838 13.8529 2.64494Z"
        fill="#7D55C7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14494 2.64494C2.09838 2.69139 2.06143 2.74656 2.03623 2.80731C2.01102 2.86805 1.99805 2.93317 1.99805 2.99894C1.99805 3.06471 2.01102 3.12983 2.03623 3.19057C2.06143 3.25132 2.09838 3.3065 2.14494 3.35294L13.1449 14.3529C13.2388 14.4468 13.3662 14.4996 13.4989 14.4996C13.6317 14.4996 13.7591 14.4468 13.8529 14.3529C13.9468 14.2591 13.9996 14.1317 13.9996 13.9989C13.9996 13.8662 13.9468 13.7388 13.8529 13.6449L2.85294 2.64494C2.8065 2.59838 2.75132 2.56143 2.69057 2.53623C2.62983 2.51102 2.56471 2.49805 2.49894 2.49805C2.43317 2.49805 2.36805 2.51102 2.30731 2.53623C2.24656 2.56143 2.19139 2.59838 2.14494 2.64494Z"
        fill="#7D55C7"
      />
    </svg>
  );
};
